<template>
  <div :class="clsx('hero', { 'animations-disabled': !animationEnabled })">
    <BackgroundGridWhite class="hero__grid">
      <AppHeader
        :animation-enabled="animationEnabled"
        :is-mobile-menu-open="isMobileMenuOpen"
        @header-resize="closeMobileMenuOnResize"
      />
      <UkaskoBigLogo class="hero__logo">
        <Advantage class="advantage advantage--glowing-star"><GlowingStarImage /></Advantage>
        <Advantage class="advantage advantage--bookmark-tabs"><BookmarkTabsImage /></Advantage>
        <Advantage class="advantage advantage--chart-increasing"><ChartIncreasingImage /></Advantage>
        <Advantage class="advantage advantage--star-struck"><StarStruckImage /></Advantage>
        <Advantage class="advantage advantage--spiral-calendar"><SpiralCalendarImage /></Advantage>
        <Advantage class="advantage advantage--laptop"><LaptopImage /></Advantage>
        <Advantage class="advantage advantage--busts-in-silhouette"><BustsInSilhouetteImage /></Advantage>
        <Advantage class="advantage advantage--bell"><BellImage /></Advantage>
        <Advantage class="advantage advantage--bar-chart"><BarChartImage /></Advantage>
        <Advantage class="advantage advantage--student"><StudentImage /></Advantage>
        <Advantage class="advantage advantage--telephone"><TelephoneImage /></Advantage>
        <Advantage class="advantage advantage--gear"><GearImage /></Advantage>
        <Advantage class="advantage advantage--money-bag"><MoneyBagImage /></Advantage>
        <Advantage class="advantage advantage--speech-balloon"><SpeechBalloonImage /></Advantage>
        <Advantage class="advantage advantage--iphone"><iPhoneImage /></Advantage>
        <Advantage class="advantage advantage--technologist"><TechnologistImage /></Advantage>
        <Advantage class="advantage advantage--hammer"><HammerImage /></Advantage>
        <Advantage class="advantage advantage--magic-wand"><MagicWandImage /></Advantage>
        <Advantage class="advantage advantage--key"><KeyImage /></Advantage>
        <Advantage class="advantage advantage--card-index"><CardIndexImage /></Advantage>
        <Advantage class="advantage advantage--balance-scale"><BalanceScaleImage /></Advantage>
        <Advantage class="advantage advantage--puzzle-piece"><PuzzlePieceImage /></Advantage>
        <Advantage class="advantage advantage--index-pointing-at-you"><IndexPointingAtYouImage /></Advantage>
        <Advantage class="advantage advantage--star-struck-2"><StarStruckImage /></Advantage>
      </UkaskoBigLogo>
      <div class="hero__text-block">
        <h1 class="hero__title" v-html="getTitleBlock('promo', 'hero', 'title')"></h1>
        <p class="hero__description" v-html="replaceFancyText(getTitleBlock('promo', 'hero', 'description'), 'hero')"></p>
      </div>
      <div
        class="hero__call-to-action"
        ref="callToAction"
      >
        <OrangeFancyButtonWithArrowAnimation
          hash="#subscribe"
          :class="clsx('hero__call-to-action-button', { 'hero__call-to-action-button--sticky': isButtonSticky })"
        >
          Записатись на презентацію
        </OrangeFancyButtonWithArrowAnimation>
        <p class="hero__motivation">Не соромтесь, це безкоштовно</p>
      </div>

      <div class="hero__footer"></div>
    </BackgroundGridWhite>
    <transition name="fade">
      <OrangeFancyButtonWithArrowAnimation
        v-if="isButtonSticky && !mobileMenuOpen"
        hash="#subscribe"
        class="hero__sticky-button"
      >
        Записатись на презентацію
      </OrangeFancyButtonWithArrowAnimation>
    </transition>
  </div>
</template>

<script>
import clsx from 'clsx';
import { textBlock } from '@/entities/text-block';
import { ukaskoFancyText } from '@/features/promo';
import { trackScroll } from '@/shared/lib/scroll';
import { OrangeFancyButtonWithArrowAnimation } from '@/shared/ui/form/buttons';
import {
  Advantage,
  BackgroundGridWhite,
  BalanceScaleImage,
  BarChartImage,
  BellImage,
  BookmarkTabsImage,
  BustsInSilhouetteImage,
  CardIndexImage,
  ChartIncreasingImage,
  GearImage,
  GlowingStarImage,
  HammerImage,
  IndexPointingAtYouImage,
  iPhoneImage,
  KeyImage,
  LaptopImage,
  MagicWandImage,
  MoneyBagImage,
  PuzzlePieceImage,
  SpeechBalloonImage,
  SpiralCalendarImage,
  StarStruckImage,
  StudentImage,
  TechnologistImage,
  TelephoneImage,
  UkaskoBigLogo
} from '@/shared/ui/promo';
import { AppHeader, promoMobileMenu } from '@/widgets/promo';

export default {
  props: {
    animationEnabled: {
      type: Boolean,
      default: true,
    },
    mobileMenuOpen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isButtonSticky: false,
      buttonOriginalPosition: 0,
    };
  },
  mounted() {
    this.calculateButtonPosition();
    this.subscribeToScroll((position) => {
      const FULL_SCREEN_HEIGHT = 800;
      const FULL_SCREEN_SCROLL_DISTANCE = 150;
      const SMALL_SCREEN_SCROLL_DISTANCE = 250;
      const PRESENTATION_BUTTON_DISABLE_DISTANCE = 800;

      const height = screen.height;
      const scrollDistance = height >= FULL_SCREEN_HEIGHT ? FULL_SCREEN_SCROLL_DISTANCE : SMALL_SCREEN_SCROLL_DISTANCE;
      let scrollPosition = this.buttonOriginalPosition - height;

      if (scrollPosition < 0) {
        scrollPosition = 0;
      }

      this.isButtonSticky = position.y >= scrollPosition + scrollDistance && position.bottom > PRESENTATION_BUTTON_DISABLE_DISTANCE;
    });
  },
  mixins: [ textBlock, ukaskoFancyText, trackScroll, promoMobileMenu ],
  components: {
    BackgroundGridWhite, AppHeader, UkaskoBigLogo, Advantage, OrangeFancyButtonWithArrowAnimation, GlowingStarImage,
    BellImage, ChartIncreasingImage, MoneyBagImage, CardIndexImage, BalanceScaleImage, SpeechBalloonImage,
    IndexPointingAtYouImage, BookmarkTabsImage, BarChartImage, StarStruckImage, LaptopImage, GearImage,
    PuzzlePieceImage, TechnologistImage, StudentImage, TelephoneImage, SpiralCalendarImage, BustsInSilhouetteImage,
    iPhoneImage, HammerImage, MagicWandImage, KeyImage
  },
  methods: {
    clsx,
    calculateButtonPosition() {
      this.$nextTick(() => {
        if (this.$refs.callToAction) {
          const rect = this.$refs.callToAction.getBoundingClientRect();
          this.buttonOriginalPosition = rect.top;
        }
      });
    },
  }
};
</script>

<style lang="scss" scoped>
.hero {
  position: relative;
  font-family: 'Inter', sans-serif;
  background-color: #CADDFC;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1440 1026'%3E%3Cg filter='url(%23f)'%3E%3Crect x='312' y='117' width='817' height='495' rx='247.5' fill='%23FFF4EA'/%3E%3C/g%3E%3Cdefs%3E%3Cfilter id='f' x='-102' y='-297' width='1645' height='1323'%3E%3CfeFlood flood-opacity='0' result='bg'/%3E%3CfeBlend in='SourceGraphic' in2='bg' result='shape'/%3E%3CfeGaussianBlur stdDeviation='207' result='blur'/%3E%3C/filter%3E%3C/defs%3E%3C/svg%3E");
  background-size: cover;
  background-position: 50% 60px;
  height: calc(100vh + 52px);
  min-height: 1000px;
  overflow: hidden;
}

.hero__grid {
  height: 100%;
}

.hero__logo {
  position: absolute;
  top: 260px;
  left: 0;
  right: 0;
  animation: hero-logo-animation 1s linear forwards;

  @media (max-width: 1050px) {
    top: 200px;
  }
}

.hero {
  &__text-block {
    position: absolute;
    bottom: 110px;
    left: 56px;

    @media (max-width: 900px) {
      bottom: 25%;
      left: 16px;
      right: 16px;
    }
  }

  &__title {
    position: relative;
    display: inline-block;
    font-family: "IBM Plex Sans", sans-serif;
    font-size: 72px;
    font-weight: 500;
    color: #313437;
    margin-bottom: 20px;
    overflow: hidden;
    opacity: 0;
    transform: translateY(100%);
    animation: hero__text-slideup-animation 0.75s linear forwards;
    animation-delay: 2s;
    max-width: 70%;

    @media (max-width: 1500px) {
      font-size: 64px;
    }

    @media (max-width: 1300px) {
      font-size: 58px;
    }

    @media (max-width: 1050px) {
      font-size: 36px;
    }

    @media (max-width: 900px) {
      max-width: 100%;
    }
  }

  &__description {
    font-size: 18px;
    font-weight: 400;
    opacity: 0;
    transform: translateY(100%);
    animation: hero__text-slideup-animation 0.5s linear forwards;
    animation-delay: 2.6s;
    max-width: 50%;

    @media (max-width: 1300px) {
      font-size: 16px;
    }

    @media (max-width: 900px) {
      max-width: 100%;
    }
  }
}

.hero__call-to-action {
  position: absolute;
  bottom: 90px;
  right: 56px;
  opacity: 0;
  transform: translateY(100%);
  animation: hero__text-slideup-animation 0.5s linear forwards;
  animation-delay: 3s;

  @media (max-width: 900px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    left: 16px;
    right: 16px;
  }
}

.hero__call-to-action-button {
  margin-bottom: 5px;
  opacity: 1;
  transition: opacity 0.2s;

  @media (max-width: 600px) {
    width: 100%;
  }

  &--sticky {
    opacity: 0;
    pointer-events: none;
  }
}

.hero__motivation {
  font-size: 18px;
  font-weight: 400;
  color: #EB883B;
  text-align: center;
  transition: opacity 0.3s ease-in-out;
}

.hero__sticky-button {
  position: fixed;
  bottom: 30px;
  right: 100px;
  z-index: 1000;

  @media (max-width: 900px) {
    width: 250px;
    left: 60%;
    transform: translateX(-50%);
  }

  @media (max-width: 750px) {
    left: 65%;
  }

  @media (max-width: 650px) {
    left: 50%;
    bottom: 100px;
  }

  @media (max-width: 500px) {
    width: 180px;

  }

  ::v-deep .orange-fancy-button {
    font-size: 14px;
    padding: 6px 12px;
  }

  ::v-deep .icon-wrapper {
    transform: scale(0.8);
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

::v-deep .hero__fancy-text {
  background: linear-gradient(90deg, #4555CC 0%, #D75693 50%, #EB893C 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  color: transparent;
}

.hero__footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 52px;
  border-radius: 52px 52px 0 0;
  background-color: #FCFDFF;
}

.advantage {
  position: absolute;
}

.advantage--glowing-star {
  top: 100px;
  left: calc(50% - 32px);
  animation: advantage--glowing-star-animation 0.5s ease-out forwards, advantage-up-down-animation 1.5s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  animation-delay: 3.5s, 7.6s;
  opacity: 0;
  z-index: -1;
}

.advantage--bookmark-tabs {
  top: 100px;
  left: calc(50% - 32px);
  animation: advantage--bookmark-tabs-animation 0.5s ease-out forwards, advantage-up-down-animation 1.5s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  animation-delay: 4.05s, 6.65s;
  opacity: 0;
  z-index: -1;
}

.advantage--chart-increasing {
  top: 100px;
  left: calc(50% - 32px);
  animation: advantage--chart-increasing-animation 0.5s ease-out forwards, advantage-up-down-animation 1.5s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  animation-delay: 4.05s, 6.7s;
  opacity: 0;
  z-index: -1;
}

.advantage--star-struck {
  top: 100px;
  left: calc(50% - 32px);
  animation: advantage--star-struck-animation 0.5s ease-out forwards, advantage-up-down-animation 1.5s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  animation-delay: 4s, 6.75s;
  opacity: 0;
  z-index: -1;
}

.advantage--spiral-calendar {
  top: 100px;
  left: calc(50% - 32px);
  animation: advantage--spiral-calendar-animation 0.5s ease-out forwards, advantage-up-down-animation 1.5s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  animation-delay: 3.55s, 6.8s;
  opacity: 0;
  z-index: -1;
}

.advantage--laptop {
  top: 100px;
  left: calc(50% - 32px);
  animation: advantage--laptop-animation 0.5s ease-out forwards, advantage-up-down-animation 1.5s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  animation-delay: 3.55s, 6.85s;
  opacity: 0;
  z-index: -1;
}

.advantage--bell {
  top: 100px;
  left: calc(50% - 32px);
  animation: advantage--bell-animation 0.5s ease-out forwards, advantage-up-down-animation 1.5s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  animation-delay: 4.5s, 6.9s;
  opacity: 0;
  z-index: -1;
}

.advantage--busts-in-silhouette {
  top: 100px;
  left: calc(50% - 32px);
  animation: advantage--busts-in-silhouette-animation 0.5s ease-out forwards, advantage-up-down-animation 1.5s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  animation-delay: 4.5s, 6.95s;
  opacity: 0;
  z-index: -1;
}

.advantage--bar-chart {
  top: 100px;
  left: calc(50% - 32px);
  animation: advantage--bar-chart-animation 0.5s ease-out forwards, advantage-up-down-animation 1.5s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  animation-delay: 4.5s, 7s;
  opacity: 0;
  z-index: -1;
}

.advantage--student {
  top: 100px;
  left: calc(50% - 32px);
  animation: advantage--student-animation 0.5s ease-out forwards, advantage-up-down-animation 1.5s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  animation-delay: 5.05s, 7.05s;
  opacity: 0;
  z-index: -1;
}

.advantage--telephone {
  top: 100px;
  left: calc(50% - 32px);
  animation: advantage--telephone-animation 0.5s ease-out forwards, advantage-up-down-animation 1.5s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  animation-delay: 6s, 7.1s;
  opacity: 0;
  z-index: -1;
}

.advantage--gear {
  top: 100px;
  left: calc(50% - 32px);
  animation: advantage--gear-animation 0.5s ease-out forwards, advantage-up-down-animation 1.5s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  animation-delay: 4s, 6.6s;
  opacity: 0;
  z-index: -1;
}

.advantage--money-bag {
  top: 100px;
  left: calc(50% - 32px);
  animation: advantage--money-bag-animation 0.5s ease-out forwards, advantage-up-down-animation 1.5s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  animation-delay: 4.5s, 6.65s;
  opacity: 0;
  z-index: -1;
}

.advantage--card-index {
  top: -180px;
  left: 22.5%;
  animation: advantage--card-index-animation 0.25s ease-out forwards, advantage-up-down-animation 1.5s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  animation-delay: 3.5s, 6.7s;
  opacity: 0;

  @media (max-width: 1300px) {
    top: -140px;
    left: calc(20% - 26px);
  }

  @media (max-width: 900px) {
    top: -130px;
    left: calc(12% - 26px);
  }

  @media (max-width: 600px) {
    top: -110px;
    left: calc(12% - 26px);
  }
}

.advantage--balance-scale {
  top: 100px;
  left: calc(50% - 32px);
  animation: advantage--balance-scale-animation 0.5s ease-out forwards, advantage-up-down-animation 1.5s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  animation-delay: 6s, 6.75s;
  opacity: 0;
  z-index: -1;

  @media (max-width: 600px) {
    opacity: 0;
    animation: none;
  }
}

.advantage--technologist {
  top: 100px;
  left: calc(50% - 32px);
  animation: advantage--technologist-animation 0.5s ease-out forwards, advantage-up-down-animation 1.5s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  animation-delay: 5s, 6.8s;
  opacity: 0;
  z-index: -1;

  @media (max-width: 600px) {
    opacity: 0;
    animation: none;
  }
}

.advantage--puzzle-piece {
  top: 100px;
  left: calc(50% - 32px);
  animation: advantage--puzzle-piece-animation 0.5s ease-out forwards, advantage-up-down-animation 1.5s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  animation-delay: 6s, 6.85s;
  opacity: 0;
  z-index: -1;

  @media (max-width: 600px) {
    opacity: 0;
    animation: none;
  }
}

.advantage--hammer {
  top: 100px;
  left: calc(50% - 32px);
  animation: advantage--hammer-animation 0.5s ease-out forwards, advantage-up-down-animation 1.5s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  animation-delay: 4.55s, 6.9s;
  opacity: 0;
  z-index: -1;
}

.advantage--speech-balloon {
  top: 100px;
  left: calc(50% - 32px);
  animation: advantage--speech-balloon-animation 0.5s ease-out forwards, advantage-up-down-animation 1.5s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  animation-delay: 4.5s, 6.95s;
  opacity: 0;
  z-index: -1;
}

.advantage--index-pointing-at-you {
  top: 100px;
  left: calc(50% - 32px);
  animation: advantage--index-point-at-you-animation 0.5s ease-out forwards, advantage-up-down-animation 1.5s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  animation-delay: 6s, 7s;
  opacity: 0;
  z-index: -1;
}

.advantage--iphone {
  top: 100px;
  left: calc(50% - 32px);
  animation: advantage--iphone-animation 0.5s ease-out forwards, advantage-up-down-animation 1.5s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  animation-delay: 5s, 7.05s;
  opacity: 0;
  z-index: -1;
}

.advantage--magic-wand {
  top: 100px;
  left: calc(50% - 32px);
  animation: advantage--magic-wand-animation 0.5s ease-out forwards, advantage-up-down-animation 1.5s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  animation-delay: 5s, 7.1s;
  opacity: 0;
  z-index: -1;

  @media (max-width: 600px) {
    opacity: 0;
    animation: none;
  }
}

.advantage--key {
  top: 100px;
  left: calc(50% - 32px);
  animation: advantage--key-animation 0.5s ease-out forwards, advantage-up-down-animation 1.5s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  animation-delay: 6s, 6.6s;
  opacity: 0;
  z-index: -1;

  @media (max-width: 600px) {
    opacity: 0;
    animation: none;
  }
}

.advantage--star-struck-2 {
  top: 100px;
  left: calc(50% - 32px);
  animation: advantage--star-struck-2-animation 0.5s ease-out forwards, advantage-up-down-animation 1.5s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  animation-delay: 6s, 6.65s;
  opacity: 0;
  z-index: -1;

  @media (max-width: 600px) {
    opacity: 0;
    animation: none;
  }
}

.animations-disabled,
.animations-disabled * {
  animation: none !important;
  animation-duration: 0s !important;
  animation-delay: 0s !important;
  transition: none !important;
}

.animations-disabled {
  .hero__logo {
    transform: translateY(0);
    opacity: 1;
  }

  .hero__title,
  .hero__description,
  .hero__call-to-action {
    opacity: 1;
    transform: translateY(0);
    clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
  }

  .advantage--glowing-star {
    top: -120px;
    left: 50%;
    opacity: 1;

    @media (max-width: 900px) {
      top: -110px;
      left: 48%;
    }

    @media (max-width: 600px) {
      top: -88px;
      left: 48%;
    }
  }

  .advantage--card-index {
    opacity: 0.2;
    top: -180px;
    left: 22.5%;

    @media (max-width: 1300px) {
      top: -132px;
      left: calc(20% - 26px);
    }

    @media (max-width: 900px) {
      top: -132px;
      left: calc(12% - 26px);
    }

    @media (max-width: 600px) {
      top: -110px;
      left: calc(12% - 26px);
    }
  }

  .advantage--bookmark-tabs {
    opacity: 1;
    top: -60px;
    left: 55%;

    @media (max-width: 600px) {
      opacity: 1;
      top: -50px;
      left: 57%;
    }
  }

  .advantage--chart-increasing {
    opacity: 1;
    top: -80px;
    left: 40%;

    @media (max-width: 600px) {
      opacity: 1;
      top: -60px;
      left: 35%;
    }
  }

  .advantage--star-struck {
    opacity: 1;
    top: 20px;
    left: 31.5%;

    @media (max-width: 900px) {
      opacity: 1;
      top: 20px;
      left: 30%;
    }

    @media (max-width: 600px) {
      opacity: 1;
      top: -30px;
      left: 20%;
    }
  }

  .advantage--spiral-calendar {
    opacity: 1;
    top: 50px;
    left: 63%;

    @media (max-width: 600px) {
      opacity: 1;
      top: -10px;
      left: 70%;
    }
  }

  .advantage--laptop {
    opacity: 1;
    top: 130px;
    left: 28%;

    @media (max-width: 600px) {
      opacity: 1;
      top: 45px;
      left: 15%;
    }
  }

  .advantage--bell {
    opacity: 0.8;
    top: -125px;
    left: 33%;

    @media (max-width: 900px) {
      opacity: 0.8;
      top: -110px;
      left: 31%;
    }

    @media (max-width: 600px) {
      opacity: 0.8;
      top: -90px;
      left: 23%;
    }
  }

  .advantage--busts-in-silhouette {
    opacity: 1;
    top: 170px;
    left: 65%;

    @media (max-width: 600px) {
      opacity: 1;
      top: 60px;
      left: 75%;
    }
  }

  .advantage--bar-chart {
    opacity: 0.8;
    top: -40px;
    left: 70%;

    @media (max-width: 600px) {
      opacity: 0.8;
      top: -50px;
      left: 80%;
    }
  }

  .advantage--student {
    opacity: 0.7;
    top: 230px;
    left: 31%;

    @media (max-width: 600px) {
      opacity: 0.7;
      top: 100px;
      left: 17%;
    }
  }

  .advantage--telephone {
    opacity: 0.6;
    top: 200px;
    left: 21%;

    @media (max-width: 900px) {
      opacity: 0.6;
      top: 200px;
      left: 18%;
    }

    @media (max-width: 600px) {
      opacity: 0.6;
      top: 75px;
      left: 2%;
    }
  }

  .advantage--gear {
    opacity: 0.6;
    top: 35px;
    left: 23%;

    @media (max-width: 900px) {
      opacity: 0.6;
      top: 35px;
      left: 19%;
    }

    @media (max-width: 600px) {
      left: 8%;
      top: 0;
    }
  }

  .advantage--money-bag {
    opacity: 1;
    top: -90px;
    left: 25%;

    @media (max-width: 900px) {
      opacity: 1;
      top: -60px;
      left: 24%;
    }

    @media (max-width: 600px) {
      opacity: 1;
      left: calc(15% - 26px);
      top: -60px;
    }
  }

  .advantage--balance-scale {
    opacity: 0.2;
    top: -120px;
    left: 15%;

    @media (max-width: 1300px) {
      opacity: 0.2;
      top: -70px;
      left: 13%;
    }

    @media (max-width: 900px) {
      opacity: 0.2;
      top: -50px;
      left: 11%;
    }

    @media (max-width: 600px) {
      opacity: 0;
      animation: none;
    }
  }

  .advantage--technologist {
    opacity: 0.4;
    top: 100px;
    left: 14%;

    @media (max-width: 900px) {
      opacity: 0.4;
      top: 100px;
      left: 11%;
    }

    @media (max-width: 600px) {
      opacity: 0;
      animation: none;
    }
  }

  .advantage--puzzle-piece {
    opacity: 0.2;
    top: 25px;
    left: 8%;

    @media (max-width: 900px) {
      opacity: 0.2;
      top: 25px;
      left: 3%;
    }

    @media (max-width: 600px) {
      opacity: 0;
      animation: none;
    }
  }

  .advantage--hammer {
    opacity: 0.4;
    top: 210px;
    left: 73%;

    @media (max-width: 600px) {
      opacity: 0.4;
      top: 105px;
      left: 83%;
    }
  }

  .advantage--speech-balloon {
    opacity: 0.5;
    top: -130px;
    left: 64%;

    @media (max-width: 900px) {
      opacity: 0.5;
      top: -120px;
      left: 64%;
    }

    @media (max-width: 600px) {
      opacity: 0.5;
      top: -95px;
      left: 70%;
    }
  }

  .advantage--index-pointing-at-you {
    opacity: 0.2;
    top: -132px;
    left: 81%;

    @media (max-width: 900px) {
      opacity: 0.2;
      top: -132px;
      left: 81%;
    }

    @media (max-width: 600px) {
      opacity: 0.2;
      top: -110px;
      left: 85%;
    }
  }

  .advantage--iphone {
    opacity: 0.5;
    top: 90px;
    left: 74%;

    @media (max-width: 600px) {
      opacity: 0.5;
      top: 20px;
      left: 85%;
    }
  }

  .advantage--magic-wand {
    opacity: 0.4;
    top: -10px;
    left: 82%;

    @media (max-width: 600px) {
      opacity: 0;
      animation: none;
    }
  }

  .advantage--key {
    opacity: 0.3;
    top: 160px;
    left: 83%;

    @media (max-width: 600px) {
      opacity: 0;
      animation: none;
    }
  }

  .advantage--star-struck-2 {
    opacity: 0.2;
    top: 60px;
    left: 90%;

    @media (max-width: 600px) {
      opacity: 0;
      animation: none;
    }
  }
}

@keyframes hero-logo-animation {
  from {
    transform: translateY(-260px);
    opacity: 0.05;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes hero__text-slideup-animation {
  0% {
    opacity: 1;
    clip-path: polygon(0 0, 100% 0, 100% 0%, 0 0%);
    transform: translateY(100%);
  }
  20% {
    opacity: 1;
    clip-path: polygon(0 0, 100% 0, 100% 20%, 0 20%);
    transform: translateY(80%);
  }
  40% {
    opacity: 1;
    clip-path: polygon(0 0, 100% 0, 100% 40%, 0 40%);
    transform: translateY(60%);
  }
  60% {
    opacity: 1;
    clip-path: polygon(0 0, 100% 0, 100% 60%, 0 60%);
    transform: translateY(40%);
  }
  80% {
    opacity: 1;
    clip-path: polygon(0 0, 100% 0, 100% 80%, 0 80%);
    transform: translateY(20%);
  }
  100% {
    opacity: 1;
    clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
    transform: translateY(0);
  }
}

@keyframes advantage--card-index-animation {
  0% {
    opacity: 0;
  }
  1% {
    opacity: 0.2;
  }
  100% {
    opacity: 0.2;
  }
}

@keyframes advantage--glowing-star-animation {
  0% {
    opacity: 0;
    top: 100px;
    left: calc(50% - 32px);
  }
  5% {
    opacity: 0.2;
  }
  15% {
    opacity: 1;
  }
  100% {
    opacity: 1;
    top: -120px;
    left: 50%;
  }
}

@media (max-width: 900px) {
  @keyframes advantage--glowing-star-animation {
    0% {
      opacity: 0;
      top: 100px;
      left: calc(50% - 32px);
    }
    5% {
      opacity: 0.2;
    }
    15% {
      opacity: 1;
    }
    100% {
      opacity: 1;
      top: -110px;
      left: 48%;
    }
  }
}

@media (max-width: 600px) {
  @keyframes advantage--glowing-star-animation {
    0% {
      opacity: 0;
      top: 100px;
      left: calc(50% - 32px);
    }
    5% {
      opacity: 0.2;
    }
    15% {
      opacity: 1;
    }
    100% {
      opacity: 1;
      top: -88px;
      left: 48%;
    }
  }
}

@keyframes advantage--laptop-animation {
  0% {
    opacity: 0;
    top: 100px;
    left: calc(50% - 32px);
  }
  5% {
    opacity: 0.2;
  }
  15% {
    opacity: 1;
  }
  100% {
    opacity: 1;
    top: 130px;
    left: 28%;
  }
}

@media (max-width: 600px) {
  @keyframes advantage--laptop-animation {
    0% {
      opacity: 0;
      top: 100px;
      left: calc(50% - 32px);
    }
    5% {
      opacity: 0.2;
    }
    15% {
      opacity: 1;
    }
    100% {
      opacity: 1;
      top: 45px;
      left: 15%;
    }
  }
}

@keyframes advantage--spiral-calendar-animation {
  0% {
    opacity: 0;
    top: 100px;
    left: calc(50% - 32px);
  }
  5% {
    opacity: 0.2;
  }
  15% {
    opacity: 1;
  }
  100% {
    opacity: 1;
    top: 50px;
    left: 63%;
  }
}

@media (max-width: 600px) {
  @keyframes advantage--spiral-calendar-animation {
    0% {
      opacity: 0;
      top: 100px;
      left: calc(50% - 32px);
    }
    5% {
      opacity: 0.2;
    }
    15% {
      opacity: 1;
    }
    100% {
      opacity: 1;
      top: -10px;
      left: 70%;
    }
  }
}

@keyframes advantage--gear-animation {
  0% {
    opacity: 0;
    top: 100px;
    left: calc(50% - 32px);
  }
  5% {
    opacity: 0.2;
  }
  15% {
    opacity: 0.6;
  }
  100% {
    opacity: 0.6;
    top: 35px;
    left: 23%;
  }
}

@media (max-width: 900px) {
  @keyframes advantage--gear-animation {
    0% {
      opacity: 0;
      top: 100px;
      left: calc(50% - 32px);
    }
    5% {
      opacity: 0.2;
    }
    15% {
      opacity: 0.6;
    }
    100% {
      opacity: 0.6;
      top: 35px;
      left: 19%;
    }
  }
}

@media (max-width: 600px) {
  @keyframes advantage--gear-animation {
    0% {
      opacity: 0;
      top: 100px;
      left: calc(50% - 32px);
    }
    5% {
      opacity: 0.2;
    }
    15% {
      opacity: 0.6;
    }
    100% {
      left: 8%;
      top: 0;
    }
  }
}

@keyframes advantage--star-struck-animation {
  0% {
    opacity: 0;
    top: 100px;
    left: calc(50% - 32px);
  }
  5% {
    opacity: 0.2;
  }
  15% {
    opacity: 1;
  }
  100% {
    opacity: 1;
    top: 20px;
    left: 31.5%;
  }
}

@media (max-width: 900px) {
  @keyframes advantage--star-struck-animation {
    0% {
      opacity: 0;
      top: 100px;
      left: calc(50% - 32px);
    }
    5% {
      opacity: 0.2;
    }
    15% {
      opacity: 1;
    }
    100% {
      opacity: 1;
      top: 20px;
      left: 30%;
    }
  }
}

@media (max-width: 600px) {
  @keyframes advantage--star-struck-animation {
    0% {
      opacity: 0;
      top: 100px;
      left: calc(50% - 32px);
    }
    5% {
      opacity: 0.2;
    }
    15% {
      opacity: 1;
    }
    100% {
      opacity: 1;
      top: -30px;
      left: 20%;
    }
  }
}

@keyframes advantage--chart-increasing-animation {
  0% {
    opacity: 0;
    top: 100px;
    left: calc(50% - 32px);
  }
  5% {
    opacity: 0.2;
  }
  15% {
    opacity: 1;
  }
  100% {
    opacity: 1;
    top: -80px;
    left: 40%;
  }
}

@media (max-width: 600px) {
  @keyframes advantage--chart-increasing-animation {
    0% {
      opacity: 0;
      top: 100px;
      left: calc(50% - 32px);
    }
    5% {
      opacity: 0.2;
    }
    15% {
      opacity: 1;
    }
    100% {
      opacity: 1;
      top: -60px;
      left: 35%;
    }
  }
}

@keyframes advantage--bookmark-tabs-animation {
  0% {
    opacity: 0;
    top: 100px;
    left: calc(50% - 32px);
  }
  5% {
    opacity: 0.2;
  }
  15% {
    opacity: 1;
  }
  100% {
    opacity: 1;
    top: -60px;
    left: 55%;
  }
}

@media (max-width: 600px) {
  @keyframes advantage--bookmark-tabs-animation {
    0% {
      opacity: 0;
      top: 100px;
      left: calc(50% - 32px);
    }
    5% {
      opacity: 0.2;
    }
    15% {
      opacity: 1;
    }
    100% {
      opacity: 1;
      top: -50px;
      left: 57%;
    }
  }
}

@keyframes advantage--money-bag-animation {
  0% {
    opacity: 0;
    top: 100px;
    left: calc(50% - 32px);
  }
  5% {
    opacity: 0.2;
  }
  15% {
    opacity: 1;
  }
  100% {
    opacity: 1;
    top: -90px;
    left: 25%;
  }
}

@media (max-width: 900px) {
  @keyframes advantage--money-bag-animation {
    0% {
      opacity: 0;
      top: 100px;
      left: calc(50% - 32px);
    }
    5% {
      opacity: 0.2;
    }
    15% {
      opacity: 1;
    }
    100% {
      opacity: 1;
      top: -60px;
      left: 24%;
    }
  }
}

@media (max-width: 600px) {
  @keyframes advantage--money-bag-animation {
    0% {
      opacity: 0;
      top: 100px;
      left: calc(50% - 32px);
    }
    5% {
      opacity: 0.2;
    }
    15% {
      opacity: 1;
    }
    100% {
      opacity: 1;
      left: calc(15% - 26px);
      top: -60px;
    }
  }
}

@keyframes advantage--bell-animation {
  0% {
    opacity: 0;
    top: 100px;
    left: calc(50% - 32px);
  }
  5% {
    opacity: 0.2;
  }
  15% {
    opacity: 0.8;
  }
  100% {
    opacity: 0.8;
    top: -125px;
    left: 33%;
  }
}

@media (max-width: 900px) {
  @keyframes advantage--bell-animation {
    0% {
      opacity: 0;
      top: 100px;
      left: calc(50% - 32px);
    }
    5% {
      opacity: 0.2;
    }
    15% {
      opacity: 0.8;
    }
    100% {
      opacity: 0.8;
      top: -110px;
      left: 31%;
    }
  }
}

@media (max-width: 600px) {
  @keyframes advantage--bell-animation {
    0% {
      opacity: 0;
      top: 100px;
      left: calc(50% - 32px);
    }
    5% {
      opacity: 0.2;
    }
    15% {
      opacity: 0.8;
    }
    100% {
      opacity: 0.8;
      top: -90px;
      left: 23%;
    }
  }
}

@keyframes advantage--bar-chart-animation {
  0% {
    opacity: 0;
    top: 100px;
    left: calc(50% - 32px);
  }
  5% {
    opacity: 0.2;
  }
  15% {
    opacity: 0.8;
  }
  100% {
    opacity: 0.8;
    top: -40px;
    left: 70%;
  }
}

@media (max-width: 600px) {
  @keyframes advantage--bar-chart-animation {
    0% {
      opacity: 0;
      top: 100px;
      left: calc(50% - 32px);
    }
    5% {
      opacity: 0.2;
    }
    15% {
      opacity: 0.8;
    }
    100% {
      opacity: 0.8;
      top: -50px;
      left: 80%;
    }
  }
}

@keyframes advantage--speech-balloon-animation {
  0% {
    opacity: 0;
    top: 100px;
    left: calc(50% - 32px);
  }
  5% {
    opacity: 0.2;
  }
  15% {
    opacity: 0.5;
  }
  100% {
    opacity: 0.5;
    top: -140px;
    left: 64%;
  }
}

@media (max-width: 900px) {
  @keyframes advantage--speech-balloon-animation {
    0% {
      opacity: 0;
      top: 100px;
      left: calc(50% - 32px);
    }
    5% {
      opacity: 0.2;
    }
    15% {
      opacity: 0.5;
    }
    100% {
      opacity: 0.5;
      top: -120px;
      left: 64%;
    }
  }
}

@media (max-width: 600px) {
  @keyframes advantage--speech-balloon-animation {
    0% {
      opacity: 0;
      top: 100px;
      left: calc(50% - 32px);
    }
    5% {
      opacity: 0.2;
    }
    15% {
      opacity: 0.5;
    }
    100% {
      opacity: 0.5;
      top: -95px;
      left: 70%;
    }
  }
}

@keyframes advantage--busts-in-silhouette-animation {
  0% {
    opacity: 0;
    top: 100px;
    left: calc(50% - 32px);
  }
  5% {
    opacity: 0.2;
  }
  15% {
    opacity: 1;
  }
  100% {
    opacity: 1;
    top: 170px;
    left: 65%;
  }
}

@media (max-width: 600px) {
  @keyframes advantage--busts-in-silhouette-animation {
    0% {
      opacity: 0;
      top: 100px;
      left: calc(50% - 32px);
    }
    5% {
      opacity: 0.2;
    }
    15% {
      opacity: 1;
    }
    100% {
      opacity: 1;
      top: 60px;
      left: 75%;
    }
  }
}

@keyframes advantage--hammer-animation {
  0% {
    opacity: 0;
    top: 100px;
    left: calc(50% - 32px);
  }
  5% {
    opacity: 0.2;
  }
  15% {
    opacity: 0.4;
  }
  100% {
    opacity: 0.4;
    top: 210px;
    left: 73%;
  }
}

@media (max-width: 600px) {
  @keyframes advantage--hammer-animation {
    0% {
      opacity: 0;
      top: 100px;
      left: calc(50% - 32px);
    }
    5% {
      opacity: 0.2;
    }
    15% {
      opacity: 0.4;
    }
    100% {
      opacity: 0.4;
      top: 105px;
      left: 83%;
    }
  }
}

@keyframes advantage--technologist-animation {
  0% {
    opacity: 0;
    top: 100px;
    left: calc(50% - 32px);
  }
  5% {
    opacity: 0.2;
  }
  15% {
    opacity: 0.4;
  }
  100% {
    opacity: 0.4;
    top: 100px;
    left: 14%;
  }
}

@media (max-width: 900px) {
  @keyframes advantage--technologist-animation {
    0% {
      opacity: 0;
      top: 100px;
      left: calc(50% - 32px);
    }
    5% {
      opacity: 0.2;
    }
    15% {
      opacity: 0.4;
    }
    100% {
      opacity: 0.4;
      top: 100px;
      left: 11%;
    }
  }
}

@keyframes advantage--iphone-animation {
  0% {
    opacity: 0;
    top: 100px;
    left: calc(50% - 32px);
  }
  5% {
    opacity: 0.2;
  }
  15% {
    opacity: 0.5;
  }
  100% {
    opacity: 0.5;
    top: 90px;
    left: 74%;
  }
}

@media (max-width: 600px) {
  @keyframes advantage--iphone-animation {
    0% {
      opacity: 0;
      top: 100px;
      left: calc(50% - 32px);
    }
    5% {
      opacity: 0.2;
    }
    15% {
      opacity: 0.5;
    }
    100% {
      opacity: 0.5;
      top: 20px;
      left: 85%;
    }
  }
}

@keyframes advantage--magic-wand-animation {
  0% {
    opacity: 0;
    top: 100px;
    left: calc(50% - 32px);
  }
  5% {
    opacity: 0.2;
  }
  15% {
    opacity: 0.4;
  }
  100% {
    opacity: 0.4;
    top: -10px;
    left: 82%;
  }
}

@keyframes advantage--student-animation {
  0% {
    opacity: 0;
    top: 100px;
    left: calc(50% - 32px);
  }
  5% {
    opacity: 0.2;
  }
  15% {
    opacity: 0.7;
  }
  100% {
    opacity: 0.7;
    top: 230px;
    left: 31%;
  }
}

@media (max-width: 600px) {
  @keyframes advantage--student-animation {
    0% {
      opacity: 0;
      top: 100px;
      left: calc(50% - 32px);
    }
    5% {
      opacity: 0.2;
    }
    15% {
      opacity: 0.7;
    }
    100% {
      opacity: 0.7;
      top: 100px;
      left: 17%;
    }
  }
}

@keyframes advantage--key-animation {
  0% {
    opacity: 0;
    top: 100px;
    left: calc(50% - 32px);
  }
  5% {
    opacity: 0.2;
  }
  15% {
    opacity: 0.3;
  }
  100% {
    opacity: 0.3;
    top: 160px;
    left: 83%;
  }
}

@keyframes advantage--star-struck-2-animation {
  0% {
    opacity: 0;
    top: 100px;
    left: calc(50% - 32px);
  }
  5% {
    opacity: 0.2;
  }
  15% {
    opacity: 0.2;
  }
  100% {
    opacity: 0.2;
    top: 60px;
    left: 90%;
  }
}

@keyframes advantage--index-point-at-you-animation {
  0% {
    opacity: 0;
    top: 100px;
    left: calc(50% - 32px);
  }
  5% {
    opacity: 0.2;
  }
  15% {
    opacity: 0.2;
  }
  100% {
    opacity: 0.2;
    top: -150px;
    left: 81%;
  }
}

@media (max-width: 900px) {
  @keyframes advantage--index-point-at-you-animation {
    0% {
      opacity: 0;
      top: 100px;
      left: calc(50% - 32px);
    }
    5% {
      opacity: 0.2;
    }
    15% {
      opacity: 0.2;
    }
    100% {
      opacity: 0.2;
      top: -140px;
      left: 81%;
    }
  }
}

@media (max-width: 600px) {
  @keyframes advantage--index-point-at-you-animation {
    0% {
      opacity: 0;
      top: 100px;
      left: calc(50% - 32px);
    }
    5% {
      opacity: 0.2;
    }
    15% {
      opacity: 0.2;
    }
    100% {
      opacity: 0.2;
      top: -110px;
      left: 85%;
    }
  }
}

@keyframes advantage--puzzle-piece-animation {
  0% {
    opacity: 0;
    top: 100px;
    left: calc(50% - 32px);
  }
  5% {
    opacity: 0.2;
  }
  15% {
    opacity: 0.2;
  }
  100% {
    opacity: 0.2;
    top: 25px;
    left: 8%;
  }
}

@media (max-width: 900px) {
  @keyframes advantage--puzzle-piece-animation {
    0% {
      opacity: 0;
      top: 100px;
      left: calc(50% - 32px);
    }
    5% {
      opacity: 0.2;
    }
    15% {
      opacity: 0.2;
    }
    100% {
      opacity: 0.2;
      top: 25px;
      left: 3%;
    }
  }
}

@keyframes advantage--balance-scale-animation {
  0% {
    opacity: 0;
    top: 100px;
    left: calc(50% - 32px);
  }
  5% {
    opacity: 0.2;
  }
  15% {
    opacity: 0.2;
  }
  100% {
    opacity: 0.2;
    top: -120px;
    left: 15%;
  }
}

@media (max-width: 1300px) {
  @keyframes advantage--balance-scale-animation {
    0% {
      opacity: 0;
      top: 100px;
      left: calc(50% - 32px);
    }
    5% {
      opacity: 0.2;
    }
    15% {
      opacity: 0.2;
    }
    100% {
      opacity: 0.2;
      top: -70px;
      left: 13%;
    }
  }
}

@media (max-width: 900px) {
  @keyframes advantage--balance-scale-animation {
    0% {
      opacity: 0;
      top: 100px;
      left: calc(50% - 32px);
    }
    5% {
      opacity: 0.2;
    }
    15% {
      opacity: 0.2;
    }
    100% {
      opacity: 0.2;
      top: -50px;
      left: 11%;
    }
  }
}

@keyframes advantage--telephone-animation {
  0% {
    opacity: 0;
    top: 100px;
    left: calc(50% - 32px);
  }
  5% {
    opacity: 0.2;
  }
  15% {
    opacity: 0.6;
  }
  100% {
    opacity: 0.6;
    top: 200px;
    left: 21%;
  }
}

@media (max-width: 900px) {
  @keyframes advantage--telephone-animation {
    0% {
      opacity: 0;
      top: 100px;
      left: calc(50% - 32px);
    }
    5% {
      opacity: 0.2;
    }
    15% {
      opacity: 0.6;
    }
    100% {
      opacity: 0.6;
      top: 200px;
      left: 18%;
    }
  }
}

@media (max-width: 600px) {
  @keyframes advantage--telephone-animation {
    0% {
      opacity: 0;
      top: 100px;
      left: calc(50% - 32px);
    }
    5% {
      opacity: 0.2;
    }
    15% {
      opacity: 0.6;
    }
    100% {
      opacity: 0.6;
      top: 75px;
      left: 2%;
    }
  }
}

@keyframes advantage-up-down-animation {
  0% { transform: translateY(0); }
  5% { transform: translateY(-2px); }
  10% { transform: translateY(-4px); }
  15% { transform: translateY(-5px); }
  45% { transform: translateY(-5px); }
  50% { transform: translateY(-2px); }
  55% { transform: translateY(0); }
  60% { transform: translateY(3px); }
  65% { transform: translateY(5px); }
  95% { transform: translateY(5px); }
  100% { transform: translateY(0); }
}
</style>
